import React from 'react';
import PropTypes from 'prop-types';
import OutsourceBadge from "../../shared/components/OutsourceBadge";
import CompanyAutocomplete from "../../shared/components/CompanyAutocomplete";

export default class OutsourceTreeItem extends React.Component {

  constructor(props){
    super(props);

    this.onChange = this.onChange.bind(this);
  }

  onChange(companySelected) {
    if (companySelected && companySelected[0]){
      this.props.contract.company.id = companySelected[0].id;
      this.props.contract.company.name = companySelected[0].name;
    } else if (!companySelected || !companySelected[0]){
      this.props.contract.company.id = -1;
      this.props.contract.company.name = "";
    }
  }

  renderAddChildren(){
    if (!this.props.contract.can_add) { // Si no can add no permitimos añadir hijos
      return null;
    }
    if(!this.props.contract.company || this.props.contract.company.level === 3){
      return null;
    }
    return(
      <a onClick={this.props.onAddChildren}>
        <span className="badge pull-right">
          <i className="material-icons">add</i>
        </span>
      </a>
    );
  }

  renderRemoveChildren(contract){
    if (!contract.can_remove) { // Si no can_remove no permitimos borrar
      return null;
    }
    if (this.props.allowRemoveChildren) {
      return(
        <a onClick={() => {
          if (contract.contract_id){
            this.props.onRemoveChildren(contract.contract_id);
            this.forceUpdate();
          }
        }}>
                <span className="badge pull-right">
                  <i className="material-icons">clear</i>
                </span>
        </a>
      );
    }
  }

  renderChildren(children){
    if (children){
      return(
        <ul>
          {children.map((contract, i) => {
              return(
                <OutsourceTreeItem
                  key={i}
                  contract={contract}
                  onRemoveChildren={(id) => {
                    for(let i = 0; i < this.props.contract.children.length; i++){
                      if (this.props.contract.children[i].contract_id === id ){
                        this.props.contract.children.splice(i, 1);
                        break;
                      }
                    }
                    this.forceUpdate();
                  }}
                  onAddChildren={() => {
                    contract.children.push({
                      contract_id: Math.random() * -1,
                      company: {
                        id: -1,
                        name: '',
                        level: contract.company.level + 1
                      },
                      can_add: true,
                      can_remove: true,
                      children: []
                    });
                    this.forceUpdate();
                  }}
                />
              );
            }
          )}
        </ul>
      );
    }
    return null;
  }

  render() {
    const { contract } = this.props;
    if (!contract){
      return null;
    }
    return (
      <li>
        <div className="row">
          <div className="col-xs-1">
            <OutsourceBadge level={contract.company && contract.company.level ? contract.company.level : null}/>
          </div>
          <div className="col-xs-8">
            <CompanyAutocomplete
              company={contract.company}
              onChange={this.onChange}
            />
          </div>
          <div className="col-xs-3">
            {this.renderRemoveChildren(contract)}
            {this.renderAddChildren()}
          </div>
        </div>
        {this.renderChildren(contract.children)}
      </li>
    );
  }

}


OutsourceTreeItem.propTypes = {
  contract: PropTypes.any.isRequired,
  onRemoveChildren: PropTypes.func,
  onAddChildren: PropTypes.func,
  allowRemoveChildren: PropTypes.bool,
};

OutsourceTreeItem.defaultProps = {
  onRemoveChildren: (id) => {},
  onAddChildren: () => {},
  allowRemoveChildren: true,
};



// WEBPACK FOOTER //
// ./src/app/works/components/OutsourceTreeItem.js